import React, { useState, useEffect } from 'react';
import { Grid, IconButton, Tooltip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Snackbar, Breadcrumbs, Typography, CircularProgress, TextField, Button, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem } from '@mui/material';
import { Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import Filtro from '../../../components/Filtro/Filtro';
import { Link } from 'react-router-dom';
import api from 'services/api';

function Usuarios() {
	const [usuarios, setUsuarios] = useState([]);
	const [filtro, setFiltro] = useState('');
	const [mensagemSucesso, setMensagemSucesso] = useState('');
	const [excluidoComSucesso, setExcluidoComSucesso] = useState(false);
	const [isFetched, setIsFetched] = useState(false);
	const [carregando, setCarregando] = useState(true);

	// Estados para o modal de edição
	const [editModalOpen, setEditModalOpen] = useState(false);
	const [usuarioAtual, setUsuarioAtual] = useState({ id: '', nome: '', email: '', status: 'Ativo' });

	// Função para buscar dados
	const fetchUsuarios = async () => {
		setCarregando(true);
		try {
			const response = await api.get(`/admin/usuarios`);
			setUsuarios(response.data);
			setIsFetched(true); // Marca como dados já buscados
		} catch (error) {
			console.error('Erro ao buscar usuários:', error);
		} finally {
			setCarregando(false);
		}
	};

	useEffect(() => {
		if (!isFetched) {
			fetchUsuarios();
		}
	}, [isFetched]);

	const handleFiltroChange = (novoFiltro) => {
		setFiltro(novoFiltro);
	};

	const handleExcluirUsuario = async (usuarioId, nomeUsuario) => {
		const confirmar = window.confirm(`Tem certeza que deseja excluir ${nomeUsuario}?`);
		if (confirmar) {
			try {
				await api.delete(`/admin/usuarios/${usuarioId}`);
				await fetchUsuarios();  // Atualiza a lista após excluir o usuário
				setMensagemSucesso('Usuário excluído com sucesso');
				setExcluidoComSucesso(true);
				setTimeout(() => {
					setExcluidoComSucesso(false);
					setMensagemSucesso('');
				}, 4000);
			} catch (error) {
				console.error('Erro ao excluir usuário:', error);
			}
		}
	};

	// Função para abrir o modal de edição e preencher os campos
	const handleEditarUsuario = (usuario) => {
		setUsuarioAtual({
			id: usuario.id,
			nome: usuario.nome,
			email: usuario.email,
			status: usuario.status, // Aqui você mantém o valor atual como 'Ativo' ou 'Inativo'
		});
		setEditModalOpen(true); // Abre o modal
	};

	// Função para atualizar o usuário
	const handleSalvarEdicao = async () => {
		try {
			await api.put(`/admin/usuarios/${usuarioAtual.id}`, {
				nome: usuarioAtual.nome,
				email: usuarioAtual.email,
				status: usuarioAtual.status, // Enviar 'Ativo' ou 'Inativo'
			});
			await fetchUsuarios(); // Atualiza a lista após salvar
			setMensagemSucesso('Usuário atualizado com sucesso');
			setExcluidoComSucesso(true);
			setTimeout(() => {
				setExcluidoComSucesso(false);
				setMensagemSucesso('');
			}, 4000);
		} catch (error) {
			console.error('Erro ao atualizar usuário:', error);
		}
		setEditModalOpen(false); // Fecha o modal
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setUsuarioAtual({ ...usuarioAtual, [name]: value });
	};

	const usuariosFiltrados = usuarios.filter(usuario =>
		usuario.nome.toLowerCase().includes(filtro.toLowerCase()) ||
		usuario.email.toLowerCase().includes(filtro.toLowerCase()) ||
		usuario.status.toLowerCase().includes(filtro.toLowerCase()) ||
		(usuario.municipio?.municipio || '').toLowerCase().includes(filtro.toLowerCase())
	);

	function destacarTexto(texto, filtro) {
    if (!filtro) return texto; // Se não houver filtro, retorna o texto original.
    
    const partes = texto.toLowerCase().split(filtro.toLowerCase());
    const termoFiltrado = texto.substring(
        texto.toLowerCase().indexOf(filtro.toLowerCase()),
        texto.toLowerCase().indexOf(filtro.toLowerCase()) + filtro.length
    );

    return (
        <>
            {partes.map((parte, index) => (
                <span key={index}>
                    {parte}
                    {index < partes.length - 1 && (
                        <span style={{ backgroundColor: 'yellow' }}>{termoFiltrado}</span>
                    )}
                </span>
            ))}
        </>
    );
}

	return (
		<Grid container sx={{ minHeight: '88vh' }}>
			<Grid item xs={10} md={8} lg={12} style={{ padding: '0 2em' }}>
				<Breadcrumbs aria-label="breadcrumb" style={{ marginBottom: '20px' }}>
					<Link color="inherit" to="/admin/principal">
						Home
					</Link>
					<Typography color="textPrimary">Usuarios</Typography>
				</Breadcrumbs>
				<Grid container justifyContent="flex-end" alignItems="center" style={{}}>
					<Grid item>
						<Filtro onFiltroChange={handleFiltroChange} />
					</Grid>
				</Grid>
				{carregando ? (
					<Grid style={{ justifyContent: 'center', alignItems: 'center', width: '100%', display: 'flex' }}>
						<CircularProgress />
					</Grid>

				) : (
					<TableContainer component={Paper} style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
						<Table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 10px' }}>
							<TableHead >
								<TableRow>
									<TableCell style={{ fontWeight: 'bold' }}>ID</TableCell>
									<TableCell style={{ fontWeight: 'bold' }}>Nome</TableCell>
									<TableCell style={{ fontWeight: 'bold' }}>Email</TableCell>
									<TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
									<TableCell style={{ fontWeight: 'bold' }}>Perfil</TableCell>
									<TableCell style={{ fontWeight: 'bold' }}>Municipio</TableCell>
									{/* <TableCell style={{ fontWeight: 'bold'}}>Cadastro</TableCell> */}
									{/* <TableCell style={{ fontWeight: 'bold'}}>Primeiro Acesso</TableCell> */}
									<TableCell style={{ fontWeight: 'bold' }}>Ações</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{usuariosFiltrados.map(usuario => (
									<TableRow key={usuario.id} style={{ backgroundColor: '#ffffff', marginBottom: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
										<TableCell>{destacarTexto(usuario.id.toString(), filtro)}</TableCell>
										<TableCell>{destacarTexto(usuario.nome, filtro)}</TableCell>
										<TableCell>{destacarTexto(usuario.email, filtro)}</TableCell>
										<TableCell>{destacarTexto(usuario.status, filtro)}</TableCell>
										<TableCell>{destacarTexto(usuario.perfil === 3 ? 'Administrador' : 'Usuário Comum', filtro)}</TableCell>
										<TableCell>{destacarTexto(usuario.municipio?.municipio || '', filtro)}</TableCell>
										<TableCell style={{ display: 'flex', justifyContent: 'space-around' }}>
											<Tooltip title="Editar">
												<IconButton aria-label="Editar" onClick={() => handleEditarUsuario(usuario)}>
													<EditIcon style={{ color: '#2196f3' }} />
												</IconButton>
											</Tooltip>
											<Tooltip title="Excluir">
												<IconButton aria-label="Excluir" onClick={() => handleExcluirUsuario(usuario.id, usuario.nome)}>
													<DeleteIcon style={{ color: '#f44336' }} />
												</IconButton>
											</Tooltip>
										</TableCell>
									</TableRow>
								))}
							</TableBody>

						</Table>
					</TableContainer>
				)}

				{/* Modal de edição */}
				<Dialog open={editModalOpen} onClose={() => setEditModalOpen(false)} aria-labelledby="form-dialog-title">
					<DialogTitle id="form-dialog-title">Editar Usuário</DialogTitle>
					<DialogContent>
						<TextField
							autoFocus
							margin="dense"
							name="nome"
							label="Nome"
							type="text"
							fullWidth
							value={usuarioAtual.nome}
							onChange={handleInputChange}
						/>
						<TextField
							margin="dense"
							name="email"
							label="Email"
							type="email"
							fullWidth
							value={usuarioAtual.email}
							onChange={handleInputChange}
						/>
						<Select
							margin="dense"
							name="status"
							fullWidth
							value={usuarioAtual.status}
							onChange={handleInputChange}
						>
							<MenuItem value="Ativo">Ativo</MenuItem>
							<MenuItem value="Inativo">Inativo</MenuItem>
						</Select>
					</DialogContent>
					<DialogActions>
						<Button onClick={() => setEditModalOpen(false)} color="primary">
							Cancelar
						</Button>
						<Button onClick={handleSalvarEdicao} color="primary">
							Salvar
						</Button>
					</DialogActions>
				</Dialog>

				<Snackbar
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					open={excluidoComSucesso}
					autoHideDuration={4000}
					onClose={() => setExcluidoComSucesso(false)}
					message={mensagemSucesso}
					action={
						<React.Fragment>
							<IconButton size="small" aria-label="close" color="inherit" onClick={() => setExcluidoComSucesso(false)}>
								<span style={{ fontSize: '1.5rem' }}>×</span>
							</IconButton>
						</React.Fragment>
					}
				/>
			</Grid>
		</Grid>
	);
}

export default Usuarios;
